import {
	Collapse,
	Drawer,
	Icon,
	IconButton,
	Paper,
	Typography,
	useTheme,
	Box,
} from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import CustomTreeView from "./customTreeView";
import { useEffect, useState } from "react";

export default function SideBar(props) {
	const {
		titlePage = "",
		setTitlePage = () => {},
		openSideBar = false,
		setOpenSideBar = () => {},
		openDrawer = false,
		setOpenDrawer = () => {},
		Perfil = <></>,
	} = props;
	const theme = useTheme();
	const colorMode = theme?.palette?.mode;
	const navigate = useNavigate();

	const [isInternal, setIsInternal] = useState(false);

	// const { openSideBar, setOpenSideBar, openDrawer, setOpenDrawer } =
	//   useOutletContext();
	// const { openSideBar, setOpenSideBar, openDrawer, setOpenDrawer } =
	//   useOutletContext();

	const logoDark = `${
		window?.config?.REACT_APP_LOGO_EXTERNO_DARK ||
		process.env.REACT_APP_LOGO_EXTERNO_DARK ||
		""
	}`;

	const handleDrawerToggle = () => {
		setOpenDrawer((prevState) => !prevState);
	};
	const [openPaper, setOpenPaper] = useState(false);
	const path = window.location.pathname;
	const isMirror = path.includes("mirror");

	const widthSideBar = (open) => (open ? 270 : 56);
	const styles = {
		container: { display: "flex" },
		paper: {
			overflow: "hidden",
			flex: "0 0 auto",
			display: window.innerWidth >= 1350 ? "flex" : "none",
			zIndex: 1,
			background: theme.palette.gradient.sidebar,
			top: isMirror ? 40 : 0,
			position: "sticky",
			height: `calc( 100vh - ${isMirror ? 40 : 0}px )`,
			borderRadius: 0,
		},
		drawer: {
			display: window.innerWidth < 1350 ? "flex" : "none",
			"& .MuiDrawer-paper": {
				background: theme.palette.gradient.sidebar,
				overflow: "hidden",
				display: "flex",
				flexDirection: "column",
			},
		},

		icons: {
			color:
				colorMode === "light"
					? `${theme.palette.black.darker}99`
					: `${theme.palette.white.lighter}B3`,
		},
		containerOutlet: { flexGrow: 1, paddingTop: 5, paddingInline: 3 },
		buttonMenuDawer: {
			color: colorMode === "light" ? "black" : "white",
			zIndex: 2,
		},
		boxMenuAndLogo: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "flex-start",
			paddingX: 1,
			width: "270px",
		},
		iconLogo: {
			width: "fit-content",
			height: "fit-content",
			margin: 2,
			ml: 3,
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-start",
			"&:hover": {
				cursor: "pointer",
			},
		},
		imgIcon: {
			width: 170,
			height: "auto",
		},
		IconButtonLogo: {
			padding: 0,
			borderRadius: 0,
			width: "220px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			transform: "translateX(-20px)",
			"&:hover": { cursor: "pointer", background: "transparent" },
		},
		justifyPerfil: {
			display: "flex",
			flexDirection: "column",
			height: "90%",
			justifyContent: "space-between",
		},
		contentContainer: {
			display: "flex",
			overflowY: "auto",
			"::-webkit-scrollbar-thumb": {
				backgroundColor: theme.palette.scrollBarFixed.main,
			},
			"::-webkit-scrollbar-track": {
				backgroundColor: theme.palette.scrollBarFixed.secondary,
			},
		},
	};

	useEffect(() => {
		setIsInternal(window.location.pathname.includes("/interno"));
	}, [window.location.pathname]);

	return (
		<>
			<Drawer
				open={openDrawer}
				onClose={() => setOpenDrawer(false)}
				sx={styles.drawer}
			>
				<Box sx={styles.boxMenuAndLogo}>
					<IconButton sx={styles.buttonMenuDawer} onClick={handleDrawerToggle}>
						<MenuIcon sx={{ color: theme.palette.white.main }} />
					</IconButton>
					<IconButton
						sx={styles.IconButtonLogo}
						href={isInternal ? "/interno/resumo" : "/resumo"}
					>
						<Icon sx={styles.iconLogo}>
							<img src={logoDark} style={styles.imgIcon} alt="imagem" />
						</Icon>
					</IconButton>
				</Box>
				<Box sx={styles.justifyPerfil}>
					<Box sx={styles.contentContainer}>
						<CustomTreeView
							open={openDrawer}
							setOpen={setOpenDrawer}
							titlePage={titlePage}
							setTitlePage={setTitlePage}
							closeOnClickItem
							{...props}
						/>
					</Box>
					{Perfil && Perfil}
				</Box>
			</Drawer>
			<Paper
				sx={styles.paper}
				// onMouseEnter={() => setOpenPaper(true)}
				// onMouseLeave={() => setOpenPaper(false)}
				elevation={0}
			>
				<Collapse
					in={openSideBar ? openSideBar : openPaper}
					orientation="horizontal"
					collapsedSize={widthSideBar(false)}
				>
					<Box sx={styles.boxMenuAndLogo}>
						<IconButton
							sx={styles.buttonMenuDawer}
							onClick={() => {
								setOpenSideBar((preValue) => {
									localStorage.setItem(
										"sidebarCollapsed",
										JSON.stringify(!preValue),
									);
									return !preValue;
								});
							}}
						>
							<MenuIcon sx={{ color: theme.palette.white.main }} />
						</IconButton>
						<IconButton
							sx={styles.IconButtonLogo}
							href={isInternal ? "/interno/resumo" : "/resumo"}
						>
							<Icon sx={styles.iconLogo}>
								<img src={logoDark} style={styles.imgIcon} alt="imagem" />
							</Icon>
						</IconButton>
					</Box>
					<Box sx={styles.justifyPerfil}>
						<Box sx={styles.contentContainer}>
							<CustomTreeView
								open={openSideBar ? openSideBar : openPaper}
								setOpen={setOpenSideBar}
								titlePage={titlePage}
								setTitlePage={setTitlePage}
								{...props}
							/>
						</Box>
						{Perfil && Perfil}
					</Box>
				</Collapse>
			</Paper>
		</>
	);
}
